/* eslint-disable max-len */
export const common = {
  'pd-processing-policy-file-name': 'pd_processing_policy_ru.pdf',
  'user-agreement-sm-podbor-file-name': '',
  'accept-agreement-to-continue': 'Для продолжения необходимо дать согласие на обработку персональных данных',
  'i-accept-user-data-proccesing': 'Я даю согласие на обработку моих персональных данных',
  yes: 'Да',
  no: 'Нет',
  continue: 'Продолжить',
  start: 'Начать',
  skip: 'Продолжить',
  delete: 'Удалить',
  cancel: 'Отмена',
  registration: 'Регистрация',
  russia: 'Россия',
  ukraine: 'Украина',
  belarus: 'Беларусь',
  'cookie-agreement': 'Мы используем файлы cookie, чтобы адаптировать предложения в соответствии с твоими потребностями и обеспечить максимальное удобство при взаимодействии с сайтом. Продолжая пользоваться сайтом, ты соглашаешься с использованием файлов cookie.',
  'accept-and-close': 'Принять и закрыть',
  'action-confirmation': 'Подтверждение действия',
  'execute-action': 'Выполнить действие?',
  ok: 'Ок',
  'choose-date': 'Выбери дату',
  'birth-date': 'Дата рождения',
  'add-resume': 'Добавь резюме',
  'invalid-file-type': 'Недопустимый тип файла',
  'cannot-load-stores': 'Не удалось загрузить данные магазина. Обратись к администраторам.',
  'nothing-found': 'Ничего не найдено',
  'store-business-card': 'Визитка магазина',
  'date-time-creation': 'Дата/время создания',
  vacancy: 'Вакансии',
  store: 'Магазин',
  'file-upload-error': 'Ошибка загрузки файла. Повторите попытку',
  'file-remove-error': 'Ошибка удаления файла. Повторите попытку',
  'file-upload-success': 'Файл успешно загружен',
  'file-remove-success': 'Файл успешно удалён',
  'file-already-uploaded': 'Вы уже загрузили этот файл',
};
